export function formatNumber(number: number, full?: boolean) {
  if (!number) {
    return null;
  }

  if (full) {
    return number.toLocaleString();
  }

  if (number >= 1000000) {
    return (number / 1000000).toFixed(1) + "m";
  } else if (number >= 1000) {
    return (number / 1000).toFixed(1) + "k";
  } else {
    return number.toString();
  }
}
